<div class="auth_form profie_setup tutor_side">
  <div class="auth_head">
    <p-button
  *ngIf="activeTab > 0"
  rounded
  severity="info"
  variant="outlined"
  icon="pi pi-arrow-left"
  (click)="onPrevClick()"
></p-button>
    <h2>Personal Details</h2>
    <p>Creating your account is just a few steps away.</p>
  </div>

  <div class="profile_progress">
    <div class="progress_bar">
      <notchmark-custom-progress
        height="4px"
        [progressValue]="progressValueFor(0)"
        trackColor="#5337811A"
        primaryColor="#533781"
      ></notchmark-custom-progress>
      <notchmark-custom-progress
        height="4px"
        [progressValue]="progressValueFor(1)"
        trackColor="#5337811A"
        primaryColor="#533781"
      ></notchmark-custom-progress>
      <notchmark-custom-progress
        height="4px"
        [progressValue]="progressValueFor(2)"
        trackColor="#5337811A"
        primaryColor="#533781"
      ></notchmark-custom-progress>
      <notchmark-custom-progress
        height="4px"
        [progressValue]="progressValueFor(3)"
        trackColor="#5337811A"
        primaryColor="#533781"
      ></notchmark-custom-progress>
    </div>
  </div>

  <p-tabs [(value)]="activeTab" class="v2">
    <p-tabpanels>
      <!-- Step 1 -->
      <p-tabpanel [value]="0">
        <form [formGroup]="step1Form" class="form pt-0">
          <div class="form_grid gap_p">
            <div class="w_100">
              <ul class="upload_image circle gap_p">
                <li class="w_100">
                  <figure>
                    <input
                      type="file"
                      (change)="onAvatarSelected($event, 'image')"
                    />
                    <img
                      [src]="imageUrl() || assetsConst.userPlaceholder"
                      alt="user profile"
                    />
                    <figcaption class="edit">
                      <img [src]="assetsConst.editIcon" alt="Icon" />
                    </figcaption>
                  </figure>
                </li>
              </ul>
              @if (step1Form.get('avatar')?.touched &&
              step1Form.get('avatar')?.hasError('required')) {
              <small class="error_msg"
                >{{ "Image" | translate }} {{ "isRequired" | translate }}</small
              >
              }
            </div>

            <div class="w_100">
              <input
                class="form_field"
                pInputText
                placeholder="Full Name"
                formControlName="fullName"
                appSpaceAtFirst
                notchmarkFullNameOnly
                maxlength="40"
              />
              @if (step1Form.get('fullName')?.touched &&
              step1Form.get('fullName')?.hasError('required')) {
              <small class="error_msg"
                >{{ "Name" | translate }} {{ "isRequired" | translate }}</small
              >
              } @else if (step1Form.get('fullName')?.touched &&
              step1Form.get('fullName')?.hasError('maxlength') ) {
              <small class="error_msg">{{
                "Name cannot be more than 40 characters" | translate
              }}</small>
              }
            </div>

            <div class="w_100">
              <p-datepicker
  class="form_field"
  formControlName="dob"
  [iconDisplay]="'input'"
  [showIcon]="true"
  inputId="icondisplay"
  placeholder="Date of Birth"
  [maxDate]="maxDob"
  [defaultDate]="eighteenYearsAgo"  
></p-datepicker>

              @if (step1Form.get('dob')?.touched && step1Form.get('dob')?.hasError('required')) {
              <small class="error_msg"
                >{{ "Date of birth" | translate }}
                {{ "isRequired" | translate }}</small
              >
              }
            </div>

            <div class="w_100 relative">
              <input
                class="form_field"
                pInputText
                placeholder="Email Address"
                appSpaceAtFirst
                formControlName="email"
              />
              <!-- <span class="verify_link">Verify</span> -->
              <ng-container *ngIf="isEmailVerified; else emailVerify">
                <span class="verify_link c_success">Verified</span>
              </ng-container>
              <ng-template #emailVerify>
                <span
                  class="verify_link"
                  *ngIf="!step1Form.get('email')?.disabled"
                  (click)="openVerify('email')"
                  >Verify</span
                >
              </ng-template>
              @if (submitting()) { @let emailError = getEmailError(); @if
              (emailError) {
              <small class="error_msg">
                {{ emailError.message | translate }}
              </small>
              } }
            </div>

            <div class="w_100 relative">
              <p-iconfield variant="on">
                <input
                  #tutorPhoneRef
                  pInputText
                  notchmark-phone
                  class="form_field"
                  inputId="on_label"
                  formControlName="phone"
                  placeholder="Enter Phone Number"
                  (phoneChange)="phoneChange($event)"
                  autocomplete="off"
                />
                <ng-container *ngIf="isPhoneVerified; else phoneVerify">
                  <span class="verify_link c_success">Verified</span>
                </ng-container>
                <ng-template #phoneVerify>
                  <span
                    class="verify_link"
                    *ngIf="!step1Form.get('phone')?.disabled"
                    (click)="openVerify('phone')"
                    >Verify</span
                  >
                </ng-template>
                @if (step1Form.get('phone')?.touched && 
                step1Form.get('phone')?.hasError('required') ) {
                <small class="error_msg">Phone Number is required</small>
                } @else if (step1Form.get('phone')?.touched && 
                step1Form.get('phone')?.hasError('maxlength')) {
                <small class="error_msg"
                  >Max phone number length exceeded</small
                >
                } @else if (step1Form.get('phone')?.touched && 
                step1Form.get('phone')?.hasError('minlength')) {
                <small class="error_msg">Min phone number length not met</small>
                }
              </p-iconfield>
            </div>
          </div>
        </form>
      </p-tabpanel>

      <!-- Step 2 -->
      <p-tabpanel [value]="1">
        <form [formGroup]="step2Form" class="form pt-0">
          <div class="form_grid gap_p">
            <div class="w_100">
              <p-select
                [options]="qualifications()"
                formControlName="qualification"
                optionLabel="name"
                placeholder="Qualification"
                name="qualification"
                class="form_field"
              >
              </p-select>
              @if (step2Form.get('qualification')?.touched &&
              step2Form.get('qualification')?.hasError('required')) {
              <small class="error_msg">{{
                "Qualification is required" | translate
              }}</small>
              }
            </div>

            <div class="w_100">
              <input
                class="form_field"
                notchmarkPriceOnly
                pInputText
                placeholder="Experience  (years)"
                formControlName="experience"
              />
              @if (step2Form.get('experience')?.touched &&
              step2Form.get('experience')?.hasError('required')) {
              <small class="error_msg">{{
                "Experience is required" | translate
              }}</small>
              } @else if (step2Form.get('experience')?.touched &&
              step2Form.get('experience')?.hasError('pattern')) {
              <small class="error_msg">{{
                "Please enter a valid number" | translate
              }}</small>
              }
            </div>

            <div class="w_100">
              <div class="hd_5 s_head mb_15">
                <h2>Subject You Taught</h2>
              </div>
              <div class="checkbox_list row">
                <label
                  class="w_50"
                  *ngFor="let subj of subjects()"
                  [for]="'subj_' + subj._id"
                >
                  <p-checkbox
                    [inputId]="'subj_' + subj._id"
                    name="subjects"
                    [binary]="true"
                    [ngModelOptions]="{ standalone: true }"
                    [ngModel]="isSubjectSelected(subj)"
                    (onChange)="onSubjectChange(subj, $event.checked)"
                  >
                  </p-checkbox>
                  {{ subj.name }}
                </label>
              </div>
              @if (step2Form.get('subjects')?.touched &&
              step2Form.get('subjects')?.hasError('required')) {
              <small class="error_msg">{{
                "Please select at least one subject" | translate
              }}</small>
              }
            </div>
            <div class="w_100">
              <div class="upload_file">
                <figure>
                  <img [src]="assetsConst.uploadIcon" alt="icon" />
                </figure>
                <div class="upload_cnt hd_6">
                  <h3>Upload Certificate(optional)</h3>
                  <small>pdf, docx, txt (10mb limit)</small>
                </div>

                <p-button size="small" rounded>
                  Select File
                  <img
                    *ngIf="!certificateUrl()"
                    [src]="assetsConst.fileIcon"
                    alt="icon"
                  />
                </p-button>
                <input
                  type="file"
                  (change)="onCertificateSelected($event, 'doc')"
                />
              </div>
              <div
                *ngIf="certificateFileType() === 'image' && certificateUrl()"
                class="preview-container"
              >
                <img
                  [src]="certificateUrl()"
                  alt="preview"
                  class="image-preview"
                />
                <button
                  class="remove-btn"
                  (click)="removeCertificate()"
                  type="button"
                >
                  <span class="close-icon">×</span>
                </button>
              </div>
              <div
                *ngIf="certificateFileType() === 'pdf' && certificateUrl()"
                class="pdf-container"
              >
                <div class="pdf-info">
                  <img
                    [src]="assetsConst.pdficon"
                    alt="pdf-icon"
                    class="pdf-icon"
                  />
                  <a [href]="certificateUrl()" target="_blank" class="pdf-link">
                    {{ certificateFileName() }}
                  </a>
                </div>
                <button
                  class="remove-btn"
                  (click)="removeCertificate()"
                  type="button"
                >
                  <span class="close-icon">×</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </p-tabpanel>

      <p-tabpanel [value]="2">
        <form [formGroup]="step3Form" class="form pt-0">
          <div class="form_grid gap_p">
            <div class="w_100">
              <input
                class="form_field"
                pInputText
                appSpaceAtFirst
                placeholder="Bank Name"
                formControlName="bankName"
                [class.ng-invalid]="
                  submitting() && step3Form.get('bankName')?.invalid
                "
              />
              @if (step3Form.get('bankName')?.touched && step3Form.get('bankName')?.hasError('required')) {
  <small class="error_msg">{{ "Bank name is required" | translate }}</small>
}
            </div>

            <div class="w_100">
              <input
                class="form_field"
                pInputText
                appSpaceAtFirst
                placeholder="Account Holder's Name"
                formControlName="accountHolder"
                [class.ng-invalid]="
                  submitting() && step3Form.get('accountHolder')?.invalid
                "
              />
              @if (step3Form.get('accountHolder')?.touched &&
              step3Form.get('accountHolder')?.hasError('required')) {
              <small class="error_msg">{{
                "Account holder name is required" | translate
              }}</small>
              }
            </div>

            <div class="w_100">
              <input
                class="form_field"
                pInputText
                appSpaceAtFirst
                placeholder="Branch Name"
                formControlName="branchName"
                [class.ng-invalid]="
                  submitting() && step3Form.get('branchName')?.invalid
                "
              />
              @if (step3Form.get('branchName')?.touched &&
              step3Form.get('branchName')?.hasError('required')) {
              <small class="error_msg">{{
                "Branch name is required" | translate
              }}</small>
              }
            </div>

            <div class="w_100">
              <input
                class="form_field"
                pInputText
                appSpaceAtFirst
                placeholder="Bank Code"
                formControlName="bankCode"
                [class.ng-invalid]="
                  submitting() && step3Form.get('bankCode')?.invalid
                "
              />
              @if (step3Form.get('bankCode')?.touched &&
              step3Form.get('bankCode')?.hasError('required')) {
              <small class="error_msg">{{
                "Bank code is required" | translate
              }}</small>
              }
            </div>

            <div class="w_100">
              <input
                class="form_field"
                pInputText
                appSpaceAtFirst
                placeholder="Account Number"
                formControlName="accountNumber"
                [class.ng-invalid]="
                  submitting() && step3Form.get('accountNumber')?.invalid
                "
              />
              @if (step3Form.get('accountNumber')?.touched &&
              step3Form.get('accountNumber')?.hasError('required')) {
              <small class="error_msg">{{
                "Account number is required" | translate
              }}</small>
              } @else if (step3Form.get('accountNumber')?.touched &&
              step3Form.get('accountNumber')?.hasError('pattern')) {
              <small class="error_msg">{{
                "Please enter a valid account number" | translate
              }}</small>
              }
            </div>
          </div>
        </form>
      </p-tabpanel>

      <p-tabpanel [value]="3">
        <form [formGroup]="step4Form" class="form pt-0">
          <div class="form_grid gap_p">
            <div class="w_100">
              <p-select
                [options]="documents()"
                formControlName="documentType"
                optionLabel="name"
                placeholder="Select Document Type"
                name="docType"
                class="form_field"
                (onChange)="onDocumentTypeChange($event.value)"
              >
              </p-select>
            </div>

<div class="w_100" *ngIf="docDetail()?.issueDate">
  <label for="issueDate">Issue Date</label>
  <p-datepicker
    id="issueDate"
    [maxDate]="today"
    formControlName="issueDate"
    placeholder="Select Issue Date"
    [showIcon]="true"
    dateFormat="dd/mm/yy"
    class="form_field"
  />
  <small class="p-error" *ngIf="step4Form.get('issueDate')?.invalid && step4Form.get('issueDate')?.touched">
    Issue date is required
  </small>
</div>

<div class="w_100" *ngIf="docDetail()?.expiryDate">
  <label for="expiryDate">Expiry Date</label>
  <p-datepicker
    id="expiryDate"
    [minDate]="minExpiryDate"
    formControlName="expiryDate"
    placeholder="Select Expiry Date"
    [showIcon]="true"
    dateFormat="dd/mm/yy"
    class="form_field"
  />
  <small class="p-error" *ngIf="step4Form.get('expiryDate')?.invalid && step4Form.get('expiryDate')?.touched">
    Expiry date is required and must be after issue date
  </small>
</div>


            <div class="w_100" *ngIf="docDetail()?.frontImage">
              <label for="frontside">Front Side Image</label>

              <div class="upload_file v2" *ngIf="!frontImage()">
                <figure>
                  <img [src]="assetsConst.uploadIcon" alt="icon" />
                </figure>
                <div class="upload_cnt hd_6">
                  <h3>Browse photo <span> or drop here</span></h3>
                  <small
                    >Please take a clear photo with a maximum
                    <span class="d_block">
                      file size of {{ docDetail()?.maxSizeMb ?? 2 }} MB.</span
                    ></small
                  >
                </div>
                <input
                  type="file"
                  id="frontside"
                  accept=".jpg,.jpeg,.png,.webp,.pdf"
                  (change)="onFrontFileSelected($event, 'image')"
                />
              </div>

              <div
                class="image-preview-box"
                *ngIf="frontImageType() === 'image' && frontImage()"
              >
                <img
                  [src]="frontImage()"
                  alt="Front side preview"
                  class="full-preview-image"
                />
                <button
                  class="remove-btn-absolute"
                  (click)="removeFrontImage()"
                  type="button"
                >
                  <span class="close-icon">×</span>
                </button>
              </div>

              <div
                class="pdf-display-box"
                *ngIf="frontImageType() === 'pdf' && frontImage()"
              >
                <div class="pdf-content">
                  <img
                    [src]="assetsConst.pdficon"
                    alt="pdf-icon"
                    class="pdf-icon-large"
                  />
                  <a
                    [href]="frontImage()"
                    target="_blank"
                    class="pdf-link-large"
                  >
                    {{ frontImageFileName() }}
                  </a>
                </div>
                <button
                  class="remove-btn-absolute"
                  (click)="removeFrontImage()"
                  type="button"
                >
                  <span class="close-icon">×</span>
                </button>
              </div>
            </div>

            <div class="w_100" *ngIf="docDetail()?.backImage">
              <label for="backside">Back Side Image</label>
              <div class="upload_file v2" *ngIf="!backImage()">
                <figure>
                  <img [src]="assetsConst.uploadIcon" alt="icon" />
                </figure>
                <div class="upload_cnt hd_6">
                  <h3>Browse photo <span> or drop here</span></h3>
                  <small
                    >Please take a clear photo with a maximum
                    <span class="d_block">
                      file size of {{ docDetail()?.maxSizeMb ?? 2 }} MB.</span
                    ></small
                  >
                </div>
                <input
                  type="file"
                  id="backside"
                  accept=".jpg,.jpeg,.png,.webp,.pdf"
                  (change)="onBackFileSelected($event, 'image')"
                />
              </div>
              <div
                class="image-preview-box"
                *ngIf="backImageType() === 'image' && backImage()"
              >
                <img
                  [src]="backImage()"
                  alt="Back side preview"
                  class="full-preview-image"
                />
                <button
                  class="remove-btn-absolute"
                  (click)="removeBackImage()"
                  type="button"
                >
                  <span class="close-icon">×</span>
                </button>
              </div>
              <div
                class="pdf-display-box"
                *ngIf="backImageType() === 'pdf' && backImage()"
              >
                <div class="pdf-content">
                  <img
                    [src]="assetsConst.pdficon"
                    alt="pdf-icon"
                    class="pdf-icon-large"
                  />
                  <a
                    [href]="backImage()"
                    target="_blank"
                    class="pdf-link-large"
                  >
                    {{ backImageFileName() }}
                  </a>
                </div>
                <button
                  class="remove-btn-absolute"
                  (click)="removeBackImage()"
                  type="button"
                >
                  <span class="close-icon">×</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <div class="btn_flex">
    <p-button
      class="w_100"
      [label]="activeTab === 3 ? 'Submit' : 'Next'"
      (click)="onNextClick()"
    ></p-button>
  </div>
</div>
